import { Stack } from '@src/shared/ui/layout';
import type { Theme } from '@src/shared/ui/theme';
import type { ReactNode } from 'react';
import { PAGE_LAYOUT_SCROLL_CONTAINER_ID } from './constants';
import Header from './Header';
import PageContentRow from './PageContentRow';

type LayoutProps = {
  children: ReactNode;
  fillHeight?: boolean;
};

export default function Layout({ children, fillHeight = false }: LayoutProps) {
  return (
    <Stack
      id={PAGE_LAYOUT_SCROLL_CONTAINER_ID}
      useFlexGap
      spacing={1.25}
      sx={[
        // The scroll container spans the left content gutter so that inline
        // warning indicators placed there scroll with the page instead of
        // being clipped.
        (theme: Theme) => ({
          ml: `-${theme.layout.content.leftPadding}px`,
          overflowY: 'auto',
          pl: `${theme.layout.content.leftPadding}px`,
        }),
        fillHeight ? { flex: 1, minHeight: 0 } : {},
      ]}
    >
      <Header />
      <PageContentRow fillHeight={fillHeight}>{children}</PageContentRow>
    </Stack>
  );
}
